import api from '@/api';

export interface CmsPageData {
    title: string | null;
    description: string | null;
    ogImagePath: string | null;
    content: Record<string, string | null>;
    updatedAt: string | null;
}

interface CmsPageResponse {
    success: boolean;
    data: CmsPageData;
}

class CmsService {
    async getPage(slug: string): Promise<CmsPageData> {
        const response = await api.get<CmsPageResponse>(`/cms/pages/${slug}`);
        return response.data.data;
    }
}

export const cmsService = new CmsService();
export default CmsService;